import Image from "next/image";
import Link from "next/link";

import { Stack } from "@/components/ui/stack";
import { Typography } from "@/components/ui/typography";

import { siteConfig } from "@/config/site";

import { DevBadge } from "./dev-badge";

export function WordMark({ title = siteConfig.name }: { title?: string }) {
  return (
    <Stack gap={2} direction="row" align="center">
      <Link href="/">
        <Image
          src="/favicon.svg"
          className="size-6"
          alt={title}
          width={24}
          height={24}
        />
      </Link>
      <Typography
        as="span"
        size="lg"
        family="serif"
        weight="bold"
        className="truncate max-w-[240px] md:max-w-[600px]"
      >
        {title}
      </Typography>
      <DevBadge />
    </Stack>
  );
}
